import _clone from "./clone";
import _forOwn from "../object/forOwn";
import _kindOf from "./kindOf";
import _isPlainObject from "./isPlainObject";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var clone = _clone;
var forOwn = _forOwn;
var kindOf = _kindOf;
var isPlainObject = _isPlainObject;
/**
 * Recursively clone native types.
 */

function deepClone(val, instanceClone) {
  switch (kindOf(val)) {
    case "Object":
      return cloneObject(val, instanceClone);

    case "Array":
      return cloneArray(val, instanceClone);

    default:
      return clone(val);
  }
}

function cloneObject(source, instanceClone) {
  if (isPlainObject(source)) {
    var out = {};
    forOwn(source, function (val, key) {
      (this || _global)[key] = deepClone(val, instanceClone);
    }, out);
    return out;
  } else if (instanceClone) {
    return instanceClone(source);
  } else {
    return source;
  }
}

function cloneArray(arr, instanceClone) {
  var out = [],
      i = -1,
      n = arr.length,
      val;

  while (++i < n) {
    out[i] = deepClone(arr[i], instanceClone);
  }

  return out;
}

exports = deepClone;
export default exports;